export default "__VITE_ASSET__ff410cac__"